import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  FaLock,
  FaPencilAlt,
  FaPause,
  FaKey,
  // FaSyncAlt,
  FaTimes
} from "react-icons/fa";
import { showToast } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import PasswordSetModal from "../modals/PasswordSetModal";
import Swal from "sweetalert2";
import {
  getLoginAsUserNameFromLocalStorage,
  setLoginAsNameInLocalStorage
} from "../loginasuser/LoginAsUser";
import Style from "./../../assets/scss/custom.module.scss";
import {
  alertActions,
  commonErrMsg,
  customers,
  tooltips,
  userAction,
  userManage
} from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { useDispatch } from "react-redux";
import { setProfile } from "../../redux/userManagementSlice";
import {
  getDeactivateUserURL,
  getHandleLoginUserURL,
  getPasswordConfirmationURL,
  getSlectedDeletedURL,
  getUserManagementDeleteURL
  // getUserManagementResendURL
} from "../../utils/constants/apiEndPoints";
import privateAxios from "../../utils/axiosPrivate";
import { CHANGE_PASSWORD, EDIT_USER, INVOICE } from "../../route/paths";

const Topaction = (props) => {
  const { getID, handleRefreshData, data: showActionBtn } = props;
  const [knowFunction, setKnowFunction] = useState("");
  const [addPasswordModal, setAddPasswordModal] = useState(false);
  const history = useNavigate();
  const dispatch = useDispatch();

  const handleLoginUserClick = async () => {
    if (getID === "" || getID.length !== 1) {
      Swal.fire({
        title: tooltips.loginAs,
        text: customers.topAction.errMsg.item1,
        icon: "warning",
        confirmButtonText: alertActions.ok,
        confirmButtonColor: "#14bc96"
      });

      return;
    }

    try {
      const response = await privateAxios.post(getHandleLoginUserURL(getID));

      if (response.status === 200) {
        const { accessToken, refreshToken } = response.data.data;

        if (accessToken && refreshToken) {
          dispatch(setProfile({}));
          setLoginAsNameInLocalStorage(response.data.data);
          history(INVOICE);
        } else {
          const errorMessage =
            response.data?.message || userManage.errMsg.item6;
          showToast(errorMessage, showToastType.error);
        }
      } else {
        const errorMessage = response.data?.message || userManage.errMsg.item7;
        showToast(errorMessage, showToastType.error);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        userManage.errMsg.item8;
      showToast(errorMessage, showToastType.error);
    }
  };

  const handleEditUserClick = () => {
    if (getID === "" || getID.length !== 1) {
      Swal.fire({
        title: customers.topAction.eidtUser,
        text: customers.topAction.errMsg.item1,
        icon: "warning",
        confirmButtonText: alertActions.ok,
        confirmButtonColor: "#14bc96"
      });

      return;
    }
    history(EDIT_USER(getID));
  };

  const handleModalClose = () => {
    setAddPasswordModal(false);
  };

  const handlePendingDeactivate = async () => {
    try {
      const response = await privateAxios.patch(getDeactivateUserURL(getID));
      const { message } = response.data;

      if (response.status === 200) {
        handleRefreshData(true);
        showToast(message, showToastType.success);
      }
    } catch (error) {
      showToast(error.message, showToastType.error);
    }
  };

  const handleDeactiveUserClick = async () => {
    if (getID === "" || getID.length !== 1) {
      Swal.fire({
        title: customers.topAction.deactiveUser,
        text: customers.topAction.errMsg.item1,
        icon: "warning",
        confirmButtonText: alertActions.ok,
        confirmButtonColor: "#14bc96"
      });

      return;
    }
    setKnowFunction("deactive");
    setAddPasswordModal(true);
  };

  const handleChangePasswordClick = () => {
    if (getID === "" || getID.length !== 1) {
      Swal.fire({
        title: customers.topAction.changeUserPass,
        text: customers.topAction.errMsg.item1,
        icon: "warning",
        confirmButtonText: alertActions.ok,
        confirmButtonColor: "#14bc96"
      });

      return;
    }
    history(CHANGE_PASSWORD(getID));
  };

  // const handlePendingResend = async () => {
  //   try {
  //     const response = await privateAxios.get(
  //       getUserManagementResendURL(getID)
  //     );

  //     const { message } = response.data;

  //     if (response.status === 200) {
  //       showToast(message, showToastType.success);
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.status === 500) {
  //       const { errors } = error.response.data;

  //       showToast(errors.join(", "), showToastType.error);
  //     } else {
  //       showToast(commonErrMsg.item2, showToastType.error);
  //     }
  //   }
  // };

  // const handleResendClick = async () => {
  //   if (getID === "" || getID.length !== 1) {
  //     Swal.fire({
  //       title: customers.topAction.resendMail,
  //       text: customers.topAction.errMsg.item1,
  //       icon: "warning",
  //       confirmButtonText: alertActions.ok,
  //       confirmButtonColor: "#14bc96"
  //     });

  //     return;
  //   }
  //   setKnowFunction("resend");
  //   setAddPasswordModal(true);
  // };

  const handlePendingDelete = async () => {
    try {
      const response = await privateAxios.patch(
        getUserManagementDeleteURL(getID)
      );

      if (response.status === 200) {
        handleRefreshData(true);
        showToast(userManage.errMsg.item3, showToastType.success);
      }
    } catch {
      showToast(commonErrMsg.item1, showToastType.error);
    }
  };

  const handlePendingBatchDelete = async () => {
    try {
      const response = await privateAxios.post(getSlectedDeletedURL, getID);

      if (response.status === 200) {
        handleRefreshData(true);
        showToast(customers.topAction.errMsg.item2, showToastType.success);
      }
    } catch {
      showToast(commonErrMsg.item1, showToastType.error);
    }
  };

  const handleDeleteClick = async () => {
    if (getID.length === 0) {
      Swal.fire({
        title: userAction.title,
        text: customers.topAction.errMsg.item1,
        icon: "warning",
        confirmButtonText: alertActions.ok,
        confirmButtonColor: "#14bc96"
      });
      return;
    } else if (getID !== "" && getID.length <= 1) {
      setKnowFunction("delete");
      setAddPasswordModal(true);
    } else if (getID !== "" && getID.length > 1) {
      setKnowFunction("batchdelete");
      setAddPasswordModal(true);
    }
  };

  const handlePasswordEntered = async (password) => {
    try {
      const dataToSend = { password };
      const response = await privateAxios.post(
        getPasswordConfirmationURL,
        dataToSend
      );

      if (response.status === 200) {
        setAddPasswordModal(false);
        if (knowFunction === "deactive") {
          handlePendingDeactivate();
          // } else if (knowFunction === "resend") {
          //   handlePendingResend();
        } else if (knowFunction === "delete") {
          handlePendingDelete();
        } else if (knowFunction === "batchdelete") {
          handlePendingBatchDelete();
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        showToast(error.response.data.message, showToastType.error);
      } else {
        showToast(error.response.data.errors, showToastType.error);
      }
    }
  };

  const isLoginAsUserActive = !getLoginAsUserNameFromLocalStorage();

  const tooltipData = [
    {
      id: "tooltip-login",
      content: tooltips.loginAsUser,
      show: isLoginAsUserActive
    },
    { id: "tooltip-edit", content: tooltips.edit, show: true },
    { id: "tooltip-deactivate", content: tooltips.deactivate, show: true },
    { id: "tooltip-password", content: tooltips.changePassword, show: true },
    { id: "tooltip-delete", content: tooltips.delete, show: true }
  ];

  return (
    <>
      <ul
        className={`${Style.actioniconBtn} d-flex flex-wrap justify-content-end align-items-center`}
      >
        {showActionBtn.length > 0 ? (
          <>
            {isLoginAsUserActive && (
              <li>
                <button
                  onClick={handleLoginUserClick}
                  data-tooltip-id="tooltip-login"
                  type="button"
                  className="btn-primary"
                >
                  <FaLock />
                </button>
              </li>
            )}
            <li>
              <button
                onClick={handleEditUserClick}
                data-tooltip-id="tooltip-edit"
                type="button"
                className="btn-primary"
              >
                <FaPencilAlt />
              </button>
            </li>
            <li>
              <button
                onClick={handleDeactiveUserClick}
                data-tooltip-id="tooltip-deactivate"
                type="button"
                className="btn-primary"
              >
                <FaPause />
              </button>
            </li>
            <li>
              <button
                onClick={handleChangePasswordClick}
                data-tooltip-id="tooltip-password"
                type="button"
                className="btn-primary"
              >
                <FaKey />
              </button>
            </li>
            {/* <li>
              <button
                onClick={handleResendClick}
                data-tooltip-id="tooltip-resend"
                type="button"
                className="btn-primary"
              >
                <FaSyncAlt />
              </button>
            </li> */}
            <li>
              <button
                onClick={handleDeleteClick}
                data-tooltip-id="tooltip-delete"
                type="button"
                className="btn-primary"
              >
                <FaTimes />
              </button>
            </li>
          </>
        ) : null}
      </ul>
      {tooltipData
        .filter((item) => item.show)
        .map(({ id, content }) => (
          <ReactTooltip
            key={id}
            className="tooltipcustom"
            id={id}
            place="top"
            content={content}
          />
        ))}

      <PasswordSetModal
        isOpen={addPasswordModal}
        toggle={handleModalClose}
        handlePasswordEntered={handlePasswordEntered}
      />
    </>
  );
};

Topaction.propTypes = {
  getID: PropTypes.array.isRequired,
  handleRefreshData: PropTypes.func.isRequired,
  data: PropTypes.array
};

export default Topaction;
